"use client";
import axios from "axios";

export const initiateToken = async () => {
  const response = await axios.post(
    `${process.env.NEXT_PUBLIC_API_BASE_URL}/user/init`,
    {
      platform: 3,
    }
  );
  return response?.data?.data?.token;
};
